<template>
  <div>
    <v-row>
      <!-- datepicker 2 -->
      <v-col cols="4">
        <v-menu
          v-model="menu1"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              dense
              outlined
              single-line
              v-model="record.StartDate"
              label="From"
              prepend-icon="mdi-calendar-month"
              v-on="on"
              readonly
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="record.StartDate"
            @input="menu1 = false"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <!-- datepicker 2 -->
      <v-col cols="4">
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              dense
              outlined
              single-line
              v-model="record.EndDate"
              label="To"
              prepend-icon="mdi-calendar-month"
              v-on="on"
              readonly
            ></v-text-field>
          </template>
          <v-date-picker
            @change="getReport"
            v-model="record.EndDate"
            @input="menu2 = false"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="2">
        <v-btn text :loading="loader"></v-btn>
      </v-col>

      <v-col cols="2">
        <v-btn icon @click="printDoc"><v-icon>mdi-printer</v-icon></v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-text-field label="Search" v-model="search"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-data-table :headers="headers" :items="reportData" :search="search">
          <template v-slot:item.AvgBuyingPrice="{ item }">
            <span>{{ item.AvgBuyingPrice.toLocaleString() }}</span>
          </template>
          <template v-slot:item.TotalDamagedValue="{ item }">
            <span>{{ item.TotalDamagedValue.toLocaleString() }}</span>
          </template>
        </v-data-table>
        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-text-field
          label="Total Damage Value"
          v-model="total"
          dense
          filled
          outlined
          readonly
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
  data() {
    return {
      record: {},
      loader: false,
      search: null,
      menu1: false,
      menu2: false,
      reportData: [],
      TotalDamagedValue: null,
      headers: [
        { text: "Product", value: "product.Name" },
        { text: "Quantity", value: "Quantity" },
        { text: "Buying Price", value: "AvgBuyingPrice" },
        { text: "Total", value: "TotalDamagedValue" },
        { text: "Date", value: "DocDate" },
      ],
    };
  },
  computed: {
    storeName() {
      return localStorage.getItem('storeName');
    },
    total() {
      let total = 0;
      if (this.TotalDamagedValue) {
        total = this.TotalDamagedValue.toLocaleString();
      }
      return total;
    },
  },
  methods: {
    setStartDate(date) {
      this.record.StartDate = date;
    },
    setEndDate(date) {
      this.record.EndDate = date;
    },
    getReport() {
      const data = this.record;
      const url = "/get-spoiled-products";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.reportData = res.ResponseData.data;
            self.TotalDamagedValue = res.ResponseData.TotalDamagedValue;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    printDoc() {
      if (this.record.StartDate == null || this.record.EndDate == null) {
        this.$refs.snackbar.show("Please select both dates", "red");
      } else {
        this.print();
      }
    },
    print() {
      const shopName = this.storeName;
      var doc = new jsPDF({ compress: true });
      var totalPagesExp = "{total_pages_count_string}";
      // var pageHeight =
      //   doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
      var pageWidth =
        doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

      var img = new Image();
      img.src = require("@/assets/stock.png");
      doc.addImage(img, "png", 10, 5, 100, 40);

      doc.setFontSize(15);
      doc.setTextColor(0, 0, 0);
      doc.setFont("Georgia, serif");
      doc.text(shopName, pageWidth - 50, 15, "center");


      //Setting Items Title:
      doc.setFontSize(15);
      doc.text("Damaged Products Report", pageWidth / 2, 57, "center");

      doc.setFontSize(13);
      doc.text(
        `From: ${this.record.StartDate}  To:  ${this.record.EndDate}`,
        pageWidth / 2,
        62,
        "center"
      );
      doc.setFontSize(12);

      // Vairables to Hold Data
      let dataRows = [];
      let dataSummaryRows = [];

      // Columns
      var columns = [
        { title: "Product", dataKey: "Name" },
        { title: "Quantity", dataKey: "Quantity" },
        { title: "Buying Price", dataKey: "AvgBuyingPrice" },
        { title: "Total", dataKey: "TotalDamagedValue" },
        { title: "Doc Date", dataKey: "DocDate" },
      ];

      function dataSummaryColumns() {
        return [
          {
            count: "",
            name: "Amount",
          },
        ];
      }

      const TotalDamageAmount = {
        count: "Total Damages Value",
        name: this.TotalDamagedValue.toLocaleString(),
      };

      dataSummaryRows.push(TotalDamageAmount);

      doc.setTextColor(0, 0, 0);
      doc.setFontSize(11);
      doc.setFont("Georgia, serif");
      doc.text("SUMMARY", 15, 68);
      doc.autoTable({
        head: dataSummaryColumns(),
        body: dataSummaryRows,
        theme: "grid",
        tableWidth: 80,
        columnStyles: {
          count: {
            fontStyle: "bold",
          },
        },
        startY: 70,
        styles: { overflow: "hidden", cellPadding: 1, font: "Georgia, serif" },
        margin: { right: 100 },
      });

      const allData = this.reportData;
      dataRows = allData.map((alldata) => {
        return {
          Name: alldata.product.Name,
          Quantity: alldata.Quantity,
          AvgBuyingPrice: alldata.AvgBuyingPrice.toLocaleString(),
          TotalDamagedValue: alldata.TotalDamagedValue.toLocaleString(),
          DocDate: alldata.DocDate,
        };
      });

      doc.setTextColor(0, 0, 0);
      doc.setFontSize(11);
      doc.setFont("Georgia, serif");
      doc.text("DOCUMENTS", 15, doc.autoTable.previous.finalY + 8);
      doc.autoTable(columns, dataRows, {
        theme: "grid",
        startY: doc.autoTable.previous.finalY + 13,
        didDrawPage: function (data) {
          // Header
          doc.setFontSize(20);
          doc.setTextColor(40);

          // Footer
          var str = "Page " + doc.internal.getNumberOfPages();
          // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === "function") {
            str = str + " of " + totalPagesExp;
          }
          doc.setFontSize(10);

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          var pageSize = doc.internal.pageSize;
          var pageHeight = pageSize.height
            ? pageSize.height
            : pageSize.getHeight();
          doc.text(str, data.settings.margin.left, pageHeight - 10);
          //Setting Foouter
          doc.setTextColor(22, 160, 133);
          doc.setFontSize(10);
          var today = new Date();
          doc.text("" + today, pageWidth / 2, pageHeight - 5, "center");
        },
      });
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === "function") {
        doc.putTotalPages(totalPagesExp);
      }
      doc.save("Damages-report.pdf");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>